import type { CategoryContent } from '../row.js';

export const ORGANIC_CHEMISTRY: CategoryContent = {
  bscba: [
    [
      'Welk reactietype wordt gekenmerkt door een nucleofiel dat in één stap een koolstof met een goede vertrekgroep aanvalt met inversie van stereochemie?',
      [
        'SN2-substitutie',
        'Unimoleculaire eliminatie (E1)',
        'Elektrofiele aromatische substitutie (EAS)',
        'Nucleofiele acylsubstitutie',
      ],
      0,
      'SN2 is aanval van achter in één stap met inversie van stereochemie. E1 is unimoleculair met racemisatie; EAS en acylsubstitutie verschillen mechanistisch.',
    ],
    [
      'Wat is de belangrijkste functionele groep in een carbonzuur?',
      [
        'Carboxylgroep (-COOH)',
        'Een aldehyde met extra zuurstof',
        'Een ester op een primair alcohol',
        'Een keton met een nabije hydroxylgroep',
      ],
      0,
      'De carboxylgroep -COOH bestaat uit C=O en O-H. Aldehyden, esters en ketonen zijn verschillende functionele groepen met elk hun eigen chemie.',
    ],
    [
      'In een E2-eliminatiereactie, welke ruimtelijke relatie hebben de waterstof en vertrekgroep?',
      [
        'Antiperiplanair arrangement',
        'Gauche arrangement',
        'Eclipsed arrangement',
        'Geen specifieke ruimtelijke eis',
      ],
      0,
      'E2 vereist antiperiplanaire geometrie voor gelijktijdige C-H en C-LG breking. Gauche en eclipsed zijn geen eisen; E2 is stereospecifiek.',
    ],
    [
      'Welk reagens wordt gewoonlijk gebruikt om een primair alcohol tot aldehyde te oxideren?',
      [
        'Pyridinium chlorochromaat (PCC)',
        'Kaliumpermanganaat (KMnO4)',
        'Lithiumaluminium hydride (LiAlH4)',
        'Natriumborhydride (NaBH4)',
      ],
      0,
      'PCC oxideert primaire alcoholen selectief tot aldehyden onder milde voorwaarden. KMnO4 over-oxideert; LiAlH4 en NaBH4 zijn reductiemiddelen.',
    ],
    [
      'Wat beschrijft de term "regioselectiviteit" in organische reacties?',
      [
        'Voorkeur voor één positie-isomeer',
        'Voorkeur voor één stereoisomeer boven een ander',
        'De snelheid waarmee een reactie evenwicht bereikt',
        'De hoeveelheid nevenproduct gevormd',
      ],
      0,
      'Regioselectiviteit verwijst naar welke regio van een molecuul reageert. Stereoselectiviteit betreft stereoisomeren; reactiesnelheid en opbrengst zijn afzonderlijke concepten.',
    ],
    [
      'Welke stelling beschrijft correct een Grignard reagens (RMgX)?',
      [
        'Een organometaallische nucleofiel',
        'Een alkylhalogenide gebruikt in eliminatiereacties',
        'Een katalytische soort voor hydrogenering',
        'Een oxidatiemiddel voor primaire alcoholen',
      ],
      0,
      'Grignard reagens zijn organometaallische nucleofielen waardevol voor C-C bindingsvorming met carbonylen. Alkylhalogeniden zijn elektrofielen; Grignards zijn geen katalysatoren of oxidatiemiddelen.',
    ],
    [
      'Wat is de relatie tussen (R)-glyceraldehyde en (S)-glyceraldehyde?',
      [
        'Het zijn enantiomeren',
        'Het zijn diastereomeren',
        'Het zijn constitutionele isomeren',
        'Het zijn dezelfde molecuul',
      ],
      0,
      'Enantiomeren zijn niet-superimponeerbare spiegelbeelden die op één chiraalbasis verschillen. Diastereomeren verschillen op enkele maar niet alle stereocentra; constitutionele isomeren hebben verschillende connectiviteit.',
    ],
    [
      'In nucleofiele acylsubstitutie, welk intermediair ontstaat nadat de nucleofiel de carbonyl aanvalt?',
      [
        'Een tetrahedraal intermediair',
        'Een carbokation',
        'Een enolaat anion',
        'Een epoxide',
      ],
      0,
      'Nucleofiele aanval op een platte sp² koolstof vormt een tetrahedraal intermediair. Carbokationen, enolaten en epoxiden zijn verschillende soorten.',
    ],
    [
      'Welke functionele groep oxideert het gemakkelijkst onder milde voorwaarden?',
      [
        'Een primair alcohol',
        'Een ether',
        'Een amide',
        'Een alkeen',
      ],
      0,
      'Primaire alcoholen oxideren gemakkelijk door chroom(VI) en andere milde oxidatiemiddelen tot aldehyden. Ethers, amiden en alkenen weerstaan oxidatie onder normale omstandigheden.',
    ],
    [
      'Wat voor molecuul ontstaat uit een Diels-Alder reactie?',
      [
        'Een cyclohexeen',
        'Een cyclobuteen (vierring)',
        'Een bicyclische verbinding',
        'Een open-keten diene',
      ],
      0,
      'De [4+2] Diels-Alder-cyclotoevoeging vormt een zesring. Cyclobuteen ontstaat uit [2+2]; bicyclische producten vereisen meerdere reacties; open-keten producten zijn geen cycloadditen.',
    ],
    [
      'In SN1 mechanisme, wat is de snelheidsbepalende stap?',
      [
        'Carbokation vorming',
        'Nucleofiel aanval op de C-LG binding',
        'Herrangschikking van de alkylketen',
        'Vertrek van de vertrekgroep na binding van de nucleofiel',
      ],
      0,
      'De langzame stap in SN1 is vorming van het carbokation-intermediair. Nucleofiele aanval is snel en herrangschikking is optioneel. Het vertrek van de vertrekgroep gaat aan de nucleofiele binding vooraf, niet andersom.',
    ],
    [
      'Welk verbinding is een primair amine?',
      [
        'CH3-CH2-NH2',
        'CH3-CH2-NH-CH3',
        '(CH3)3N',
        'C6H5-NH2 met een benzylsubstituent op N',
      ],
      0,
      'Een primair amine heeft één alkyl-/arylgroep op stikstof en twee waterstofatomen. Secundaire aminen hebben twee groepen; tertiaire aminen hebben drie; N-gesubstitueerde anilinen zijn ook secundair.',
    ],
    [
      'Wat is de stereochemische uitkomst van hydrogenering van een alkeen met H2 en katalysator?',
      [
        'Syn toevoeging (H-atomen voegen toe aan dezelfde zijde)',
        'Anti toevoeging (H-atomen voegen toe aan tegenovergestelde zijden)',
        'Een mengsel van syn en anti producten',
        'Inversie van de dubbele bindingsgeometrie',
      ],
      0,
      'Katalytische hydrogenering voegt beide H-atomen toe aan dezelfde zijde van de alkeen (syn). Anti toevoeging treedt op met halogenen; mengsels en geometrische inversie treden niet op.',
    ],
    [
      'Welke stelling beschrijft Markovnikov\'s regel?',
      [
        'De nucleofiel voegt toe aan de koolstof met meer waterstof',
        'Bij eliminatie is het meer gesubstitueerde alkeen altijd het belangrijkste product',
        'Bij substitutie worden primaire koolstoffen altijd eerder aangevallen dan secundaire',
        'Racemische mengsels vormen altijd in polaire oplosmiddelen',
      ],
      0,
      'Markovnikov\'s regel voorspelt regioselectiviteit: H voegt toe aan de koolstof met meer H (minder gesubstitueerde). Het bepaalt niet eliminatieselectiviteit of substitutiepatronen.',
    ],
    [
      'Welke functionele groep ontstaat wanneer een keton door natriumborhydride wordt gereduceerd?',
      [
        'Een secundair alcohol',
        'Een primair alcohol',
        'Een alkaan',
        'Een aldehyde',
      ],
      0,
      'NaBH4 reduceert ketonen (en aldehyden) tot alcoholen; ketonen geven secundaire alcoholen. Primaire alcoholen komen uit aldehyden; alkanen vereisen sterkere reductiemiddelen.',
    ],
  ],
  msc: [
    [
      'In het SN1-mechanisme van een secundair alkylhalogenide, welke factor stabiliseert het carbokation-intermediair het meest?',
      [
        'Hyperconjugatie en inductieve effecten van α-alkylgroepen',
        'Resonantiestabilisatie van een aangrenzende aromatische ring',
        'Solvatatie door polaire protonenafgeving oplosmiddelen',
        'Sterische verlichting bij vertrek van vertrekgroep',
      ],
      0,
      'Hyperconjugatie en inductieve donatie van nabije koolstofatomen stabiliseren secundaire carbokationen. Aromatische resonantie geldt alleen voor benzylsystemen; solvatatie versnelt de reactie, maar stabiliseert het intermediair niet.',
    ],
    [
      'Waarom ondergaat 1,2-dimethyloxirane (propyleenoxide) regioselectieve ringopening naar de minder gesubstitueerde koolstof wanneer het onder basische omstandigheden door een nucleofiel wordt aangevallen?',
      [
        'SN2-achtige aanval van achteren op de minst belemmerde koolstof',
        'Directe nucleofiele benadering van het meer gesubstitueerde centrum vanwege elektrostatische polariteit',
        'Carbokationvorming bij voorkeur op de meer gesubstitueerde plaats',
        'Sterische blokkering van de meer gesubstitueerde koolstof door methylgroepen',
      ],
      0,
      'Epoxide-ringopening via SN2 verloopt via aanval van achteren op de minst belemmerde koolstof. Anders dan bij carbokationvorming is epoxide-opening onder basische/nucleofiele omstandigheden bimoleculair, en is de meer gesubstitueerde koolstof sterisch geblokkeerd.',
    ],
    [
      'In E1cb (conjugaatbasis) eliminatie, welk intermediair is essentieel vóór C-H bindingsbreking?',
      [
        'Een enolaat- of carbanion-intermediair',
        'Een carbokation intermediair',
        'Een cyclisch drieledige ring intermediair',
        'Een π-complex met de basiscatalysator',
      ],
      0,
      'Bij E1cb gaat deprotonering aan het verlies van de vertrekgroep vooraf, waarbij een enolaat/carbanion ontstaat. Dit wordt geclassificeerd als eliminatie (E) via een conjugaatbase-mechanisme (1cb), anders dan carbokation-gebaseerd E1 of syn-E2.',
    ],
    [
      'Welke combinatie van factoren maakt een verbinding een slechte Diels-Alder dienophiel?',
      [
        'Een elektron-donerende groep met lage sterische eis',
        'Elektron-onttrekkende groepen (EWGs) op de dubbele binding',
        'Sterische hindering van omringende bulkige groepen',
        'Hoge symmetrie van de dienophiel',
      ],
      0,
      'Diels-Alder dienofielen moeten elektron-deficiënt zijn (EWGs versnellen). Elektron-donoren deactiveren; sterische eis bemoeilijkt benadering maar is niet inherent disqualificerend; symmetrie is orthogonaal.',
    ],
    [
      'In de Wittig reactie, welk intermediair ontstaat nadat het ylide de aldehyde carbonyl aanvalt?',
      [
        'Een betaïne (1,2-dipolar zwitterion) die sluit tot een oxirane',
        'Een ylide-aldehyde adduct dat onmiddellijk fosfineoxide uitstoot',
        'Een carbokation-fosfoniumintemediair',
        'Een enol gestabiliseerd door het fosforatoom',
      ],
      0,
      'Aanval van het ylide geeft een betaïne, die sluit tot een drieledige oxirane; ontleding daarvan geeft het alkeen en fosfineoxide. De andere opties geven de verkeerde volgorde.',
    ],
    [
      'Waarom vindt E2-eliminatie van een primair alkylhalogenide zelden plaats ondanks gunstige kinetiek, terwijl secundaire en tertiaire alkylhalogeniden gemakkelijk E2 ondergaan?',
      [
        'Primaire carbokationen zijn te onstabiel; SN2 domineert',
        'Primaire C-H bindingen zijn te sterk om te breken',
        'Basiskatalytische isomerisatie blokkeert eliminatie',
        'Oplosmiddelviscositeit remt E2 voorkeur bij primaire sites',
      ],
      0,
      'Primaire alkylhalogeniden kiezen SN2 boven E2 omdat het primaire carbokation zeer onstabiel is: bimoleculaire substitutie wint het van unimoleculaire eliminatie. De C-H-sterkte is niet de barrière; isomerisatie en oplosmiddeleffecten zijn geen doorslaggevende factoren.',
    ],
    [
      'Waar heeft het concept "umpoled carbonyl" betrekking op binnen retrosynthetische analyse?',
      [
        'Omkering van carbonylpolariteit naar nucleofiel',
        'Omzetting van een keton naar enol voor selectieve substitutie',
        'Introductie van stereocentra via aldolcondensatie',
        'Activering van carbonyl via bescherming als ketal',
      ],
      0,
      'Umpolung (Duits "polariteitsomkering") zet normaal elektrofiele koolstof om in nucleofiel (bijv. via dithianen). Enolisatie, aldol en ketalbeveiliging zijn andere transformaties.',
    ],
    [
      'Wat is de stereochemische uitkomst van een [2,3]-sigmatrope verschuiving van een allylsulfoxide in de Mislow herschikking?',
      [
        'Suprafaciaal, met inversie op zwavel en allylkoolstof',
        'Antarafaciale herschikking die nieuwe alkeen-geometrie genereert',
        'Geen netto verandering in stereochemie op beide centra',
        'Exclusieve vorming van (R,R)-diastereomeer ongeacht startmateriaal',
      ],
      0,
      'De [2,3]-sigmatrope verschuiving is suprafaciaal; beide zwavelinversie en allylkoolstof inversie treden op, met voorspelbare uitkomst. Antarafaciaal, geen verandering en diastereomeer exclusiviteit zijn onjuist.',
    ],
    [
      'In de Heck reactie gekatalyseerd door Pd(0), wat is de eerste stap na oxidatieve toevoeging van het organische halogenide?',
      [
        'Migratietoevoeging van alkeen in de Pd-C binding',
        'Coördinatie van alkeen aan het Pd centrum',
        'Reductieve eliminatie om het gekoppelde product te vormen',
        'β-waterstof eliminatie van het alkylpalladium',
      ],
      0,
      'Na oxidatieve toevoeging coördineert de alkeen aan Pd en voegt in in de Pd-alkylbinding (migratietoevoeging). Reductieve eliminatie is finaal; β-waterstof eliminatie volgt toevoeging.',
    ],
    [
      'Wat is het fundamentele verschil tussen diastereomeer en enantiomeer in de context van prochiraliteit?',
      [
        'Enantiotope groepen worden pas diastereomer met een chiraal reagens',
        'Beide zijn onzichtbaar voor achirale reagens; beide vereisen chirale vergelijking om te detecteren',
        'Enantiotope groepen vereisen spiegelvlak; diastereotope groepen niet',
        'Enantiomeren zijn alleen onderscheidend door chirale oplosmiddelen; diastereomeren hebben altijd verschillende NMR signalen',
      ],
      0,
      'Enantiotope groepen worden diastereomeer wanneer behandeld met chirale reagens. Diastereotope groepen zijn intrinsiek verschillend (verschillende NMR in achirale oplosmiddelen). Beide verduidelijken symmetrieanalyse.',
    ],
    [
      'Welke metaal-carbeensoort initieert de reactie bij olefinemetathese gekatalyseerd door de Grubbs-katalysator?',
      [
        'Een ruthenium-alkylideen (Ru=CH-R) complex dat via [2+2] aan het olefine toevoegt',
        'Een ruthenium-carbokation gecoördineerd aan een kationisch fosfine',
        'Een metathesecomplex dat gelijktijdig twee olefinen bindt',
        'Een wolfraam-alkylideen dat minder selectief is dan Ru-gebaseerde katalysatoren',
      ],
      0,
      'De Grubbs-katalysator is een Ru(II)-alkylideen dat met olefinen reageert via [2+2]-cyclotoevoeging van de Ru=C-π-binding. Carbokation, dubbele olefinebinding en de vergelijking met wolfraam zijn hier onjuist.',
    ],
    [
      'Waarom is de Cope-herschikking een [3,3]-sigmatrope verschuiving in plaats van een [1,5]-verschuiving?',
      [
        '[3,3] is suprafaciaal toegestaan; [1,5] is antarafaciaal verboden',
        '[1,5]-verschuivingen vereisen een chiraal centrum dat de selectiviteit bepaalt',
        'De Cope-herschikking vormt een zesring-overgangstoestand die geometrisch onverenigbaar is met [1,5]',
        'Alleen [3,3]-verschuivingen zijn mogelijk in 1,5-diënen, vanwege de moleculaire symmetrie',
      ],
      0,
      'De Cope-herschikking betreft 6π-elektronen (4n+2, n=1), waardoor de suprafaciale [3,3]-verschuiving thermisch is toegestaan. Een [1,5]-verschuiving zou met 6π antarafaciaal en dus verboden zijn. Chiraliteit, de grootte van de overgangstoestand en symmetrie zijn hierbij niet doorslaggevend.',
    ],
    [
      'Welke eigenschap maakt benzylethers geschikt voor alcoholbescherming in een meerstapssynthese?',
      [
        'Gekliefd door hydrogenolyse (H2/Pd), stabiel voor zuur/base',
        'Orthogonaal aan acetylesters via selectieve verzeping',
        'Stabiel onder zowel zure als basische waterige omstandigheden, maar gekliefd door sterke oxidatiemiddelen',
        'Gemakkelijk geïnstalleerd via Williamson-ethersynthese en gekliefd door overmaat Grignard-reagens',
      ],
      0,
      'Benzylethers worden reductief gekliefd (H2/Pd-C) en zijn stabiel onder zuur/base, wat onafhankelijke manipulatie van andere groepen mogelijk maakt. Acetylesters, sterke oxidatiemiddelen en Grignard-klieving zijn hier niet kenmerkend voor.',
    ],
    [
      'Wat betekent de term "diastereofaciale selectiviteit" (of "diastereofaciale discriminatie") in asymmetrische synthese?',
      [
        'Voorkeursaanval op één zijde van een prochirale groep',
        'Selectieve vorming van één geometrische isomeer van alkeen',
        'Voorkeursreactie op één stereogecentreerde positie in een mesoverbinding',
        'De neiging van enantiomeren om apart te kristalliseren',
      ],
      0,
      'Diastereofaciale selectiviteit beschrijft hoe een chirale katalysator of chiraal reagens onderscheid kan maken tussen de twee zijden van een prochirale groep, waarbij één diastereomeer wordt gevormd. Geometrische isomerisatie, meso-reactiviteit en kristallisatie zijn afzonderlijke concepten.',
    ],
    [
      'Waarom wordt asymmetrische Sharpless-dihydroxylering (AD) veel gebruikt in natuurproductsynthese, ondanks de stoichiometrische inzet van chirale ligand?',
      [
        'Hoge enantioselectiviteit met katalytische osmiumomzet',
        'Het is economischer dan methoden met chirale hulpstoffen en vormt slechts één stereo-isomeer',
        'Het werkt als een echt katalytisch proces met substoichiometrisch osmium',
        'Het vereist geen beschermingsgroepen en is compatibel met alle functionele groepen',
      ],
      0,
      'Sharpless-AD is waardevol vanwege de hoge ee en directe vorming van syn-diolen; osmium wordt katalytisch gerecycled, al moeten het AD-reagens en de ligand wel in stoichiometrische hoeveelheid worden ingezet. Die stoichiometrische ligand en de compatibiliteit zijn dus reële beperkingen.',
    ],
  ],
  phd: [
    [
      'In de Eschenmoser-Claisen herschikking, wat is het intermediair dat thermale [3,3]-sigmatrope verschuiving triggert?',
      [
        'Vorming van een allylisch keteen-aminal (imidaat)',
        'Een carbokation gegenereerd uit zuurgekataliseerde activering van hydroxylgroep',
        'Een enolaat gevormd door deprotonering van β-waterstof',
        'Een concerted intermediair waarin allylisch C-O binding synchroon breekt met C-C vorming',
      ],
      0,
      'De Eschenmoser-Claisen gebruikt een keteen-aminal-intermediair (of een equivalent imidaat/zwavelylide-complex) dat de [3,3]-herschikking ondergaat. Carbokation, enolaat en een direct concerted pad geven een onjuist mechanisme.',
    ],
    [
      'Leg de stereo-elektronische eis uit voor efficiënte nucleofiele verdringing in de Finkelstein-reactie, en de relatie met de oplosbaarheid en reactiviteit van metaalhalogeniden.',
      [
        'Primaire of secundaire halogeniden kiezen voor SN2 in aprotische oplosmiddelen',
        'Tertiaire halogeniden ondergaan bij voorkeur E2 vanwege sterische hindering; polaire protische oplosmiddelen onderdrukken de nucleofiliteit',
        'De reactie wordt zuiver thermodynamisch bepaald door de stabiliteit van de producten en de kristallisatie van het metaalhalogenide',
        'Alkylfluoriden zijn het meest reactief omdat C-F-bindingen gepolariseerd zijn richting de nucleofiel',
      ],
      0,
      'De Finkelstein-reactie slaagt met primaire/secundaire halogeniden in aprotische oplosmiddelen (verhoogde anionische nucleofiliteit, onderdrukte carbokationen). Tertiaire substraten elimineren, en protische oplosmiddelen verminderen de nucleofiliteit.',
    ],
    [
      'Wat voorspelt orbitaalsymmetrieanalyse over toegestane versus verboden stereo-elektronische paden in de pericyclische [4+2] Diels-Alder-reactie?',
      [
        'Suprafaciaal [4+2] is toegestaan; antarafaciaal [4+2] is verboden',
        'Zowel het suprafaciale als het antarafaciale [4+2]-pad is even goed toegestaan vanwege de symmetrie van geconjugeerde diënen',
        'Het antarafaciale [4+2]-pad heeft de voorkeur wanneer er elektronenzuigende groepen op het dienofiel aanwezig zijn',
        'De Diels-Alder is eigenlijk een [2+4]-reactie (het dienofiel wordt eerst genoemd), wat de toegestaan/verboden-indeling verandert',
      ],
      0,
      'Met 6π-elektronen (4n+2) is [4+2] suprafaciaal toegestaan. Antarafaciaal zou een tegenovergestelde orbitaaloverlap vereisen, wat geometrisch onhaalbaar is voor diënen/dienofielen.',
    ],
    [
      'Hoe verschilt het mechanisme van oxidatieve toevoeging van een organisch halogenide aan Pd(0) qua regioselectiviteit en verloop van SN2-verdringing?',
      [
        'Oxidatieve toevoeging vormt Pd(II)-C- en Pd(II)-X-bindingen aan het metaal',
        'Beide verlopen via hetzelfde carbokation-intermediair, maar het metaal stabiliseert een ander stereo-isomeer',
        'Oxidatieve toevoeging heeft de voorkeur bij secundaire halogeniden; SN2 bij primaire halogeniden, voor hetzelfde substraat',
        'De regioselectiviteit wordt bepaald door de ionische sterkte van het oplosmiddel en de grootte van het halogenide',
      ],
      0,
      'Oxidatieve toevoeging voegt Pd(0) in de C-X-binding in, waarbij Pd(II)-C en Pd(II)-X ontstaan. SN2 is een nucleofiele aanval op koolstof met inversie. De mechanismen en substraten verschillen fundamenteel.',
    ],
    [
      'Hoe beïnvloeden de elektronische effecten van substituenten en sterische hindering de overgangstoestand bij de Cope-herschikking van een gesubstitueerd 1,5-hexadieen met elektronendonerende en elektronenzuigende groepen?',
      [
        'De plaatsing van EWG\'s/EDG\'s verlaagt ΔG‡; sterische congestie remt de reactie af',
        'EDG\'s versnellen de reactie altijd, ongeacht de positie; sterische effecten zijn verwaarloosbaar',
        'De herschikking staat onder orbitale controle; elektronische effecten zijn irrelevant',
        'Substituenteffecten zijn additief en verhogen ΔG‡ lineair met het aantal elektronendonerende groepen',
      ],
      0,
      'De Cope-herschikking volgt pericyclische (orbitale) controleregels; zowel elektronische effecten (EWG\'s versnellen) als sterische bulk in de zesring-overgangstoestand beïnvloeden de snelheid. EDG\'s werken niet uniform, en orbitale controle sluit elektronische effecten niet uit.',
    ],
    [
      'In katalytische enantioselectieve C-H functionalisatie, welk strategisch voordeel biedt asymmetrische katalyse via chirale richtingsgroep boven stoichiometrische chirale hulpstof?',
      [
        'Katalytische omzet vereist minder chiraal ligand en blijft chelatiegecontroleerd',
        'Richtingsgroepen zijn altijd selectiever dan stoichiometrische hulpstoffen, omdat ze permanent bevestigd blijven',
        'C-H-functionalisatie vereist stoichiometrische chirale hulpstoffen; katalytische methoden kunnen geen enantioselectiviteit bereiken',
        'De stereoselectiviteit wordt uitsluitend bepaald door de sterische bulk van de katalysator, onafhankelijk van het substraat',
      ],
      0,
      'Katalytische C-H-functionalisatie met richtingsgroepen gebruikt een substoichiometrische katalysator en chirale liganden. Stoichiometrische hulpstoffen vereisen een 1:1-verhouding; de plaatsselectiviteit is chelatiegecontroleerd.',
    ],
    [
      'Wat is het strategisch voordeel van een "asymmetrisch synthetisch equivalent" (of "asymmetrische umpolung") bij retrosynthetische planning van een doelmolecuul met meerdere stereocentra?',
      [
        'Legt de stereochemie vroeg vast via één enantioselectieve stap',
        'Vermindert het totale aantal stappen doordat geen chirale reagentia meer nodig zijn',
        'Garandeert dat alle volgende transformaties optreden met dezelfde relatieve stereochemie',
        'Alleen toepasbaar op natuurproducten met één stereocentrum',
      ],
      0,
      'Asymmetrische synthetische equivalenten leggen de stereochemie vroeg vast via een enantioselectieve reactie, waardoor veel latere stereoselectieve transformaties overbodig worden.',
    ],
    [
      'Leg de oorsprong uit van de afwijkende regioselectiviteit in de intramoleculaire Heck-reactie, wanneer het carbopalladium-intermediair zowel een 5-exo-trig- als een 6-endo-trig-cyclisatie kan ondergaan.',
      [
        '5-exo-trig wordt kinetisch bevoordeeld volgens de regels van Baldwin',
        '6-endo-trig is altijd sneller vanwege de geometrie van het Pd-alkeen-π-complex',
        'De selectiviteit is uitsluitend thermodynamisch afhankelijk van de stabiliteit van de twee mogelijke carbokationen',
        'De endo-trig- en exo-trig-regels gelden alleen voor niet-katalytische reacties',
      ],
      0,
      'De regels van Baldwin bevoordelen 5-exo-trig (snellere kinetiek) boven 6-endo-trig (langzamer). De Pd-katalysator stabiliseert het exo-pad. Kinetische ringsluitingsselectiviteit overwint hier de thermodynamica.',
    ],
    [
      'Wat is het belangrijkste mechanistische onderscheid tussen keten-groeipolymerisatie via vrije radicalen en levende anionische polymerisatie, wat betreft keteneindiging en molecuulgewichtsverdeling?',
      [
        'Bij vrije radicalen is de keteneindiging willekeurig (brede Mw); bij anionische polymerisatie is er geen eindiging',
        'Levende anionische polymerisatie is sneller, maar heeft een bredere molecuulgewichtsverdeling',
        'Vrije radicalen geven perfect uniforme ketenlengtes; anionische polymerisatie geeft willekeurige lengtes',
        'Beide mechanismen geven identieke polydispersiteitsindices bij hetzelfde monomeer',
      ],
      0,
      'Vrijeradicaalpolymerisatie eindigt willekeurig (brede Mw). Levende anionische polymerisatie kent geen eindiging (het dormante carbanion is stabiel), wat een smalle Mw en gecontroleerde groei oplevert.',
    ],
    [
      'Wat is het doel van "strategische bindingsdisconnectie" in de retrosynthetische analyse van natuurproducten, en hoe verschilt dit van "tactische disconnectie"?',
      [
        'Strategische disconnectie vereenvoudigt het doelmolecuul; tactische disconnectie regelt lokale details',
        'Strategische disconnectie ligt altijd in het midden van het molecuul; tactische disconnectie altijd aan de uiteinden',
        'Beide verwijzen naar hetzelfde concept, maar "strategisch" wordt gebruikt bij complexe doelmoleculen en "tactisch" bij eenvoudige',
        'Strategische disconnectie komt altijd eerst, zonder flexibiliteit in de planningsvolgorde',
      ],
      0,
      'Strategische disconnectie herleidt het doelmolecuul tot sleutelbouwblokken, wat de synthetische boom vereenvoudigt; tactische disconnectie behandelt het maskeren van functionele groepen en regiocontrole. Positie en flexibiliteit variëren; de concepten onderscheiden zich in doel en reikwijdte.',
    ],
    [
      'Waarom overschrijft chelatie van de nucleofiel (of het Grignard-reagens) door een β-amino-alcohol of hydroxylgroep de sterische controle van Felkin-Anh, in het Cram-chelatiemodel voor asymmetrische inductie?',
      [
        'Chelatie legt de benaderingszijde vast en overschrijft daarmee de sterische regels',
        'Chelatie verzwakt de C=O-binding, waardoor de koolstof elektrofieler wordt en minder afhankelijk is van sterische oriëntatie',
        'Felkin-Anh-controle geldt alleen voor niet-chelaterende Grignard-reagentia',
        'Chelatie en Felkin-Anh zijn even belangrijk en geen van beide regels overschrijft de selectiviteit',
      ],
      0,
      'Cram-chelatie creëert een starre, richtinggevende geometrie die één zijde bevoordeelt; deze stereochemische bias overschrijft de sterische argumenten van Felkin-Anh. Bindingsactivering en het type Grignard-reagens zijn hierbij niet doorslaggevend, en de modellen kunnen elkaar soms tegenspreken.',
    ],
    [
      'Wat is de stereochemische rol van het chirale ligand bij het bepalen van de enantioselectiviteit voor de aanval op één zijde van een prochiraal olefine, bij enantioselectieve epoxidatie (bijv. de Jacobsen-katalysator of de Katsuki-methode)?',
      [
        'De chirale zak creëert diastereomere overgangstoestanden, waarvan er één wordt bevoordeeld',
        'De katalysator maakt geen onderscheid tussen de olefinezijden; enantioselectiviteit ontstaat uitsluitend door de intrinsieke reactiviteit van het olefine',
        'Het omvangrijke ligand blokkeert fysiek één zijde van het olefine en verhindert benadering vanuit die richting',
        'Het ligand induceert een tijdelijk chiraal centrum op het olefine zelf, wat de volgende reactie stuurt',
      ],
      0,
      'Asymmetrische epoxidatie gebruikt een chiraal metaalcomplex dat diastereomere overgangstoestanden creëert, waarbij één benaderingsrichting duidelijk wordt bevoordeeld (discriminatie tussen de prochirale zijden).',
    ],
    [
      'Wat is het voordeel van het gebruik van een silylketeenacetal boven een vrij enolaat, wat betreft reactiemechanisme en selectiviteit, bij de Ireland-Claisen-herschikking?',
      [
        'Het silylketeenacetal geeft een schonere [3,3]-herschikking',
        'De silylgroep werkt als vertrekgroep en zet de herschikking om in een SN2-substitutie',
        'Vrije enolaten zijn selectiever, maar vereisen een stoichiometrische base; silylacetalen maken die behoefte overbodig',
        'Het silylketeenacetal en het vrije enolaat geven identieke resultaten; alleen de vereiste base verschilt',
      ],
      0,
      'Silylketeenacetalen zijn vooraf georganiseerd en stabiel bij opslag, en ondergaan de [3,3]-herschikking schoon met minimale bijreacties; de Si-O-binding helpt bij het stabiliseren van de overgangstoestand. Silicium is geen vertrekgroep; de basisbehoefte en reactiviteit verschillen, en de resultaten zijn niet identiek.',
    ],
    [
      'Wat bepaalt de "auto-katalytische" of "zelf-voortplantende" aard van bepaalde multicomponent-cyclisaties, bij cascadereacties (of dominoreacties)?',
      [
        'Vroege producten dienen als reactant of katalysator voor latere stappen',
        'Alle cascadereacties zijn inherent auto-katalytisch wanneer ze in één pot worden uitgevoerd',
        'De reactie verloopt sneller als het product voortdurend uit het reactiemengsel wordt verwijderd',
        'Auto-katalyse is alleen mogelijk in meerstapssynthesen met minstens drie verschillende reagentia',
      ],
      0,
      'Cascadereacties planten zichzelf voort wanneer een vroeg gevormd product als partner of katalysator voor de volgende stap fungeert (echte auto-katalyse). Niet alle eenpotsreacties zijn cascades; productverwijdering is niet bepalend, en het aantal reagentia is irrelevant.',
    ],
    [
      'Waarom is de Cu(I)-katalysator essentieel voor de controle van regioselectiviteit en reactiesnelheid bij klikchemie, in het bijzonder de koper(I)-gekatalyseerde azide-alkyn-cyclotoevoeging (CuAAC)?',
      [
        'Cu(I) activeert het alkyn voor een concerted [3+2]-cyclotoevoeging tot het 1,4-triazool',
        'Cu(I) werkt als eenvoudig tegenion zonder elektronisch effect op het alkyn',
        'De reactie verloopt even snel zonder koper, maar koper wordt om veiligheidsredenen toegevoegd',
        'Cu(I) katalyseert de herschikking van het aanvankelijke 1,5-triazool-isomeer naar het thermodynamische 1,4-product',
      ],
      0,
      'Cu(I) complexeert met het alkyn, verlaagt de HOMO en maakt een concerted [3+2]-cyclotoevoeging mogelijk. Het 1,4-regio-isomeer vormt zich direct als kinetisch product, niet via herschikking.',
    ],
  ],
  professor: [
    [
      'Leg uit welke selectiviteit ortho-, meta- en para-substitutie beheerst bij areen-C-H-activering in overgangsmetaal-gekatalyseerde C-H-functionalisatie, wanneer de richtingsgroep geen sterk coördinerend atoom heeft.',
      [
        'Elektronische en sterische eigenschappen, samen met zwakke chelatie, bepalen de plaats',
        'Para-selectiviteit heeft altijd de voorkeur vanwege resonantiestabilisatie van het areen-π-systeem',
        'Meta-selectiviteit is onmogelijk bij aromatische C-H-activering, tenzij er een deactiverende groep aanwezig is',
        'Ortho-, meta- en para-substitutie treden met gelijke waarschijnlijkheid op, tenzij een sterk chelaterende richtingsgroep wordt geïntroduceerd',
      ],
      0,
      'De selectiviteit bij C-H-activering ontstaat uit chelatiegeometrie, elektronische factoren en sterische bulk. Zwakke waterstofbruggen en secundaire chelatie moduleren de ortho-/meta-/para-selectiviteit.',
    ],
    [
      'Hoe verklaren de Woodward-Hoffmann-regels de schijnbare "omkering" van toegestane/verboden stereochemische paden, in de context van fotochemische [2+2]-cyclotoevoeging versus thermische Diels-Alder-cyclotoevoeging?',
      [
        'De aangeslagen toestand verandert de orbitaalsymmetrie, waardoor de regels voor [2+2] omkeren',
        'Fotochemie versnelt simpelweg de thermische paden, zonder de selectieregels te veranderen',
        'Diels-Alder-reacties zijn fotochemisch, terwijl [2+2]-cycloadditie thermisch is; het is nooit andersom',
        'De "omkering" is een kunstgreep van oplosmiddeleffecten, niet van orbitaalsymmetrie',
      ],
      0,
      '[2+2] is fotochemisch suprafaciaal toegestaan omdat de fotonpromotie de elektronische configuratie verandert, wat de uitkomst ten opzichte van de thermische route omkeert. Orbitaalsymmetrie beheerst dit, niet het oplosmiddel.',
    ],
    [
      'Welke katalysatorontwerpkenmerken (of structuurmotieven) stellen een chiraal kwaternair ammoniumion in staat hoge enantiocontrole te bereiken bij enantioselectieve fase-overdrachtskatalyse, in reacties zoals asymmetrische epoxidatie of enolaatalkylering?',
      [
        'Bulkige, stijve chirale groepen op het ammoniumion schermen één enolaatzijde af',
        'Eenvoudige alkylketens rond het ammoniumcentrum volstaan, mits het oplosmiddel zorgvuldig wordt gekozen',
        'Het tegenion (bijv. OH⁻ versus Cl⁻) is de exclusieve bron van stereochemische controle, onafhankelijk van de ammoniumstructuur',
        'Fase-overdrachtskatalyse bereikt geen hoge enantioselectiviteit, omdat het grensvlak inherent achiraal is',
      ],
      0,
      'Omvangrijke, chirale kwaternaire ammoniumkatalysatoren (bijv. Maruoka-ontwerpen) organiseren de ion-paargeometrie en schermen enolaatzijden af, wat een hoge ee oplevert. Eenvoudige alkylketens alleen geven geen enantiocontrole; het tegenion is secundair; moderne PTC bereikt zeer hoge ee via ligandontwerp.',
    ],
    [
      'De "Kishi-regel" (of uitgebreide selectiviteitsmodellen) stuurt 1,3-asymmetrische inductie in acyclische polyolsystemen binnen natuurproductsynthese. Leg de mechanistische basis uit waarom het anti-Felkin-traject vaak in onverwachte gevallen wordt waargenomen.',
      [
        'Verborgen sterische/elektronische effecten kunnen een niet-Felkin-conformeer bevoordelen',
        'Anti-Felkin-uitkomsten ontstaan altijd door chelatie en nooit zonder een hydroxyl- of aminogroep op de β-positie',
        'De Kishi-regel en het Felkin-Anh-model zijn tegenstrijdig; de ene moet altijd de andere overschrijven',
        'Anti-Felkin-selectiviteit ontstaat uitsluitend door elektronische activering van de aldehydekoolstof door aangrenzende elektronenzuigende groepen',
      ],
      0,
      'Kishi/anti-Felkin-uitkomsten weerspiegelen conformationele mobiliteit en waterstofbrugvorming, die verdergaan dan eenvoudige sterische argumenten. De modellen zijn complementair, niet tegenstrijdig.',
    ],
    [
      'Leg de oorsprong van enantiotrouwheid uit (of het gebrek daaraan) bij katalytische asymmetrische C-C-koppeling via Pd-gekatalyseerde kruiskoppeling, wanneer het Pd-alkyl-intermediair een stereogene koolstof draagt.',
      [
        'De trouwheid hangt ervan af of reductieve eliminatie sneller verloopt dan racemisatie',
        'Pd-alkyl-intermediaten ondergaan bij koppeling altijd stereochemische inversie, vanwege de aard van de oxidatieve toevoeging',
        'Enantiotrouwheid is onmogelijk bij kruiskoppeling; stereogene alkylgroepen raken altijd verloren of verward',
        'Alleen chirale liganden op palladium kunnen stereochemische trouwheid induceren; de stereochemie van het substraat is irrelevant',
      ],
      0,
      'Enantiotrouwheid hangt af van de relatieve snelheden: snelle reductieve eliminatie wint het van β-waterstofeliminatie en isomerisatie. De stereochemie van het substraat en de reactiviteit zijn essentieel.',
    ],
    [
      'Leg uit waarom gecontroleerde radicaalpolymerisatie (ATRP of RAFT) toegang geeft tot smalle polydispersiteit en blokcopolymeren, in vergelijking met het mechanisme van levende anionische polymerisatie.',
      [
        'CRP houdt de radicaalconcentratie laag via een dormant/actief-evenwicht',
        'ATRP en RAFT gebruiken anionische intermediairen en zijn in wezen gelijk aan levende anionische polymerisatie',
        'Levende anionische polymerisatie heeft een bredere polydispersiteit dan ATRP, omdat er geen evenwichtscontrole is',
        'Gecontroleerde radicaalpolymerisatie kan geen blokcopolymeren maken, omdat radicalen niet lang genoeg leven',
      ],
      0,
      'CRP (ATRP/RAFT) houdt de radicaalconcentratie laag via een dormant/actief-evenwicht, wat gecontroleerde groei en een smalle Mw oplevert. Anionische polymerisatie groeit direct (geen dormante toestand) en is met veel functionele groepen incompatibel.',
    ],
    [
      'Hoe verschillen "beschermingsgroepvrije" of "minimalistische beschermingsgroep"-strategieën in filosofie en uitvoering van traditionele routes bij de totaalsynthese van een complex natuurproduct, en wat zijn de belangrijkste synthetische uitdagingen?',
      [
        'Het benut inherente chemoselectiviteit in plaats van covalente bescherming',
        'Beschermingsgroepvrije synthese is alleen mogelijk voor natuurproducten met één functionele groep',
        'Traditionele routes zijn altijd korter dan beschermingsgroepvrije routes',
        'Beschermingsgroepvrije synthese gebruikt dezelfde reagentia en transformaties als traditionele synthesen; alleen de benaming verschilt',
      ],
      0,
      'Beschermingsgroepvrije synthese berust op chemoselectiviteit en reactiviteitstrends, waardoor het aantal stappen en de hoeveelheid afval afnemen. De aanpak is niet beperkt tot mono-functionele doelmoleculen, het aantal stappen varieert, en de benadering maakt andere reagenskeuzes.',
    ],
    [
      'Leg de oorsprong van de "beethoek" uit en hoe deze de reactiviteit en enantioselectiviteit beïnvloedt bij kruiskoppelings- of hydrogeneringsreacties, in asymmetrische katalyse met chirale bisfosfineliganden (bijv. BINAP, DuPhos).',
      [
        'Beethoek (P-M-P) bepaalt de coördinatiegeometrie en sterische ruimte',
        'De beethoek wordt uitsluitend bepaald door de lengte van de fosforbevattende linker en beïnvloedt de reactiviteit niet',
        'Alle chirale bisfosfines hebben dezelfde beethoek, ongeacht hun structuur',
        'De beethoek beïnvloedt de kleur en oplosbaarheid van de katalysator, maar niet de reactiviteit of selectiviteit',
      ],
      0,
      'De beethoek (P-M-P) bepaalt de coördinatiegeometrie van het metaal en de sterische congestie, en beheerst zo de reactiviteit en enantioselectiviteit. De stijfheid van de linker en de geometrie van de ruggengraat bepalen deze hoek.',
    ],
    [
      'Wat is het doel en het mechanistische voordeel van een "omvangrijke nucleofiel" of "geremd reductiemiddel" bij een selectieve transformatie waarbij een kleinere nucleofiel zou leiden tot bijreacties, in de synthetische organische chemie?',
      [
        'Omvangrijke nucleofielen vermijden belemmerde plaatsen door sterische uitsluiting',
        'Omvangrijke nucleofielen zijn sneller dan kleine, vanwege elektronische activering',
        'Omvangrijke nucleofielen kunnen sterisch belemmerde plaatsen niet benaderen en worden daarom gebruikt wanneer selectiviteit voor minder belemmerde plaatsen gewenst is',
        'De grootte van de nucleofiel is onafhankelijk van de selectiviteit; alleen de oplosmiddelpolariteit is van belang',
      ],
      0,
      'Omvangrijke nucleofielen vallen minder belemmerde plaatsen aan via sterische uitsluiting (bijv. DIBAL-H, LTBA), wat selectieve reducties mogelijk maakt. De selectiviteit ontstaat door de sterische congestie rond de nucleofiel.',
    ],
    [
      'Leg uit hoe waterstofbrugvorming tussen katalysator en substraat een chirale micro-omgeving creëert die hoge enantioselectiviteit oplevert zonder metaalcentrum, bij organokatalyse (imidazolidinon- of thioureakatalyse).',
      [
        'Waterstofbruggen pre-organiseren het substraat en maken onderscheid tussen de twee zijden mogelijk',
        'Waterstofbrugvorming is bij organokatalyse toevallig en draagt niet bij aan de selectiviteit',
        'Organokatalysatoren bereiken selectiviteit uitsluitend via sterische bulk, zonder elektrostatische of waterstofbrugcomponent',
        'Waterstofbrugvorming en organisatie van de overgangstoestand zijn alleen relevant bij metaalkatalyse',
      ],
      0,
      'Organokatalytische waterstofbrugvorming creëert diastereomere substraat-katalysatorcomplexen en stabiliseert één overgangstoestand, wat een hoge ee oplevert. Waterstofbruggen en elektrostatica zijn hierbij dominant.',
    ],
    [
      'Leg uit hoe de substraatstructuur (ringgrootte, alkeengeometrie en substitutiepatroon) het evenwicht en de kinetiek van ringsluitende metathese (RCM) beïnvloedt, en de neiging tot ongewenste oligomerisatie, bij macrocyclische synthese.',
      [
        'Thorpe-Ingold-effecten en intramoleculaire kinetiek bevoordelen RCM',
        'Alle ringgroottes sluiten even efficiënt bij RCM',
        'Oligomerisatie bij RCM is onvermijdelijk en kan niet worden onderdrukt door substraatontwerp',
        'Alkeengeometrie (E/Z) is irrelevant voor de selectiviteit en productverdeling bij RCM',
      ],
      0,
      'Het succes van RCM hangt af van spanningsverlichting via het Thorpe-Ingold-effect, de geometrie van de overgangstoestand en het kinetische voordeel van de intramoleculaire reactie. Het oligomerisatierisico schaalt met de substraatconcentratie.',
    ],
    [
      'Wat onderscheidt een "sleutel strategische transformatie" van een routinestap in totaalsyntheseplanning, en hoe stuurt dit de retrosynthetische analyse?',
      [
        'Bouwt in één stap complexiteit op (stereocentra, ringen) en bepaalt de strategie',
        'Sleuteltransformaties zijn altijd de laatste stappen van de synthese',
        'Alle transformaties zijn even belangrijk bij routeoptimalisatie',
        'Sleuteltransformaties moeten gebruikmaken van reacties uit de gevestigde literatuur met een opbrengst van meer dan 95%',
      ],
      0,
      'Sleutelstrategische transformaties creëren efficiënt complexiteit (stereocentra, ringen) en bepalen de strategie, ook als ze geen laatste stap zijn of geen perfect hoge opbrengst hebben. Routinestappen bouwen voort op gevestigde kennis.',
    ],
    [
      'Leg het verschil uit tussen het Type I- en Type II-fotochemische mechanisme, wat betreft de gevormde intermediairen en de selectiviteit van de uitkomsten, in fotochemische organische synthese.',
      [
        'Type I geeft radicalen; Type II draagt energie over (singlet-zuurstof)',
        'Beide typen genereren identieke producten en verschillen alleen in mechanistische naamgeving',
        'Type I vereist zichtbaar licht; Type II vereist UV-licht',
        'Type II is sneller omdat singlet-zuurstof reactiever is dan radicalen',
      ],
      0,
      'Type I-fotochemie: de aangeslagen toestand genereert radicalen (H-abstractie, fragmentatie). Type II: de aangeslagen toestand draagt energie over (bijv. aan O₂, wat singlet-zuurstof vormt). Beide hebben verschillende mechanismen en selectiviteit.',
    ],
    [
      'Welk voordeel biedt gerichte evolutie van enzymen boven het engineeren van de actieve plaats op basis van structuurvoorspellingen, in enzymatische katalyse toegepast op organische synthese?',
      [
        'Gerichte evolutie bemonstert de sequentieruimte en vindt zo niet-intuïtieve varianten',
        'Gerichte evolutie is trager en minder efficiënt dan rationeel ontwerp',
        'Rationeel ontwerp vindt altijd als eerste de optimale enzymvariant',
        'Gerichte evolutie kan geen enantioselectiviteit bereiken die verder gaat dan het startenzym',
      ],
      0,
      'Gerichte evolutie (mutagenese + screening) bemonstert de sequentieruimte empirisch en vindt zo vaak oplossingen die niet voor de hand liggen en rationeel ontwerp overtreffen. Dit maakt zowel uitbreiding van het substraatbereik als geheel nieuwe selectiviteit mogelijk.',
    ],
    [
      'Hoe verschilt het concept "atoomeconomie" van "opbrengst" bij het beoordelen van hoe milieuvriendelijk een synthesroute is?',
      [
        'Atoomeconomie is het theoretische atoomgebruik; opbrengst is de werkelijke output',
        'Atoomeconomie en opbrengst zijn identieke termen',
        'Opbrengst is belangrijker dan atoomeconomie, omdat een hoge opbrengst minimaal afval betekent',
        'Atoomeconomie is irrelevant wanneer de reactie in een groen oplosmiddel wordt uitgevoerd',
      ],
      0,
      'Atoomeconomie (de fractie startatomen die in het eindproduct terechtkomt, theoriegebaseerd) en opbrengst (werkelijk versus theoretisch, experimentgebaseerd) zijn onafhankelijke metrieken. Beide zijn van belang bij het evalueren van groene chemie.',
    ],
  ],
};
